import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  subTitle: Yup.string().required("Subheading is required"),
  spaceSize: Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value,
    )
    .positive("Space size must be positive")
    .optional(),
  industry: Yup.string(),
  sliderImages: Yup.array().min(5, "At least 5 slider images are required"),
  thumbNail: Yup.array().length(1, "Exactly 1 thumbnail image is required"),
  featuredImages: Yup.array().max(5, "No more than 5 top images are allowed"),
  beforeAfterImages: Yup.array().test(
    "even-length",
    "Comparison images must be in pairs (even number of images)",
    (val) => !val || val.filter(Boolean).length % 2 === 0,
  ),
  youtubeLink: Yup.string().url("Must be a valid URL"),
  virtualLink: Yup.array()
    .of(Yup.string().trim().url("Must be a valid URL"))
    .nullable()
    .optional(),
  textSection: Yup.array().of(
    Yup.object().shape({
      title: Yup.string().required("Title is required"),
      subTitle: Yup.string().required("Subheading is required"),
      description: Yup.string().required("Description is required"),
      textSectionImgs: Yup.array()
        .min(1, "At least 1 image is required")
        .max(3, "No more than 3 images are allowed"),
    }),
  ),
});

export const industries = [
  "Startup",
  "MNC",
  "Coworking",
  "SME",
  "Industrial",
  "Retail",
  "Institutional",
  "Co working and managed space",
];
